// Shared Zorvexl wordmark + mark. `tier` swaps the mark's gradient between
// the transit (school admin) and clearance (super admin) accent — same
// glyph, same typography, so both surfaces read as one product.
export default function Logo({ tier = 'transit', showWordmark = true, size = 40 }) {
  const gradient = tier === 'clearance'
    ? 'linear-gradient(155deg, var(--clearance), var(--clearance-deep))'
    : 'linear-gradient(155deg, var(--transit), var(--transit-deep))';

  return (
    <div className="flex items-center gap-3">
      <div
        className="grid place-items-center rounded-m shadow-1 shrink-0"
        style={{ width: size, height: size, background: gradient }}
      >
        <svg width={size * 0.5} height={size * 0.5} viewBox="0 0 20 20" fill="none">
          <path d="M3 14 L8 6 L12 11 L17 4" stroke="white" strokeWidth="2.4"
            strokeLinecap="round" strokeLinejoin="round" />
          <circle cx="17" cy="4" r="1.6" fill="white" />
        </svg>
      </div>
      {showWordmark && (
        <span className="font-display font-extrabold text-xl tracking-tight text-ink">
          Zorvexl
        </span>
      )}
    </div>
  );
}
